import React from "react";

function PromUserContextMenu({ user, position = { top: 0, left: 0 }, onClose, onVerPerfil, onReport }) {
  if (!user) return null;

  const style = {
    top: position.top ?? 0,
    left: position.left ?? 0,
  };

  return (
    <div
      className="absolute bg-white dark:bg-zinc-800 shadow-lg rounded-xl p-3 w-48 border border-yellow-500 z-50"
      style={style}
    >
      <div className="flex items-center gap-2 mb-2">
        <img
          src={user.profilePhotoUrl}
          alt={user.name}
          className="w-8 h-8 rounded-full object-cover border border-yellow-400"
        />
        <p className="font-semibold text-yellow-900 dark:text-yellow-100 truncate">{user.name}</p>
      </div>

      <div className="flex flex-col gap-1 text-sm">
        <button
          onClick={() => {
            onVerPerfil();
          }}
          className="text-left px-3 py-1 rounded hover:bg-yellow-100 dark:hover:bg-yellow-700"
        >
          Ver perfil
        </button>

        <button
          onClick={() => {
            onReport();
           // onClose();
          }}
          className="text-left px-3 py-1 rounded hover:bg-red-100 dark:hover:bg-red-700 text-red-700 dark:text-red-300"
        >
          Reportar
        </button>
      </div>
    </div>
  );
}

export default PromUserContextMenu;
